var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"app-bar",attrs:{"app":"","clipped-left":"","height":"72px"}},[_c('v-menu-icon'),_c('p',{staticClass:"header-logo"},[_c('router-link',{attrs:{"to":_vm.homePath}},[_c('img',{attrs:{"src":require("@/assets/img/header_logo.png"),"width":"200","height":"50","alt":"ゲットスルー2600"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }